import 'datatables.net-buttons/js/buttons.print'
import store from '@/store'
import lang from '@/plugins/lang'
import { nowFormat } from '@/helpers/dateHelper'

const actionPrintOriginal = $.fn.dataTable.ext.buttons.print.action

/**
 * @param {TotalsTable} totals
 */
function createTotalsTable(totals) {
    const table = document.createElement('table')
    const header = document.createElement('thead')
    const headerRow = document.createElement('tr')
    const body = document.createElement('tbody')

    totals.header.forEach(text => {
        const col = document.createElement('th')
        col.textContent = text
        headerRow.append(col)
    })

    header.append(headerRow)

    totals.body.forEach(row => {
        const elRow = document.createElement('tr')

        row.forEach(text => {
            const col = document.createElement('td')
            col.textContent = text
            elRow.append(col)
        })

        body.append(elRow)
    })

    table.append(header, body)

    if (totals.footer) {
        const footer = document.createElement('tfoot')
        const footerRow = document.createElement('tr')

        totals.footer.forEach(text => {
            const col = document.createElement('th')
            col.textContent = text
            footerRow.append(col)
        })

        footer.append(footerRow)
        table.append(footer)
    }

    return table
}

$.extend($.fn.dataTable.ext.buttons, {
    customPrint: {
        extend: 'print',
        activeFilters: () => ({}),

        /**
         * @return {TotalsTable|null}
         */
        totalsTable: () => null,

        action( e, dt, button, config ) {
            config.exportOptions.columns = dt.columns().visible().toArray().reduce((acc, v, idx) => {
                if(v) {
                    acc.push(idx)
                }
                return acc
            }, [])

            let html = ''

            Object.values(config.activeFilters()).forEach(item => {
                item.forEach(filter => {
                    html += `<b>${filter.input}: </b>${(filter.value || lang.t('no_filter'))}; `
                })

                html += '<br>'
            })

            config.message = `<p><b>${lang.t('created_at')}:</b>${nowFormat()}; <b>${lang.t('user')}: </b>${store().auth.name}</p>`+
                `<h4>${lang.t('filters')}</h4>`+
                html + '<br>'

            const totals = config.totalsTable()

            if (totals) {
                const table = createTotalsTable(totals)

                table.className = 'table table-sm table-hover text-nowrap w-auto'

                config.message += `<h4>${lang.t('report:totals')}</h4>`
                config.message += table.outerHTML + '<br>'
            }

            actionPrintOriginal.call(this, e, dt, button, config)
        },
        customize( dom ) {
            let imgEl = document.createElement('img')
            imgEl.style.maxWidth = '400px';
            imgEl.style.maxHeight = '120px';
            imgEl.src = store().logo_dark

            dom.document.body.insertBefore(imgEl, dom.document.body.firstChild)
        },
    }
})
